import type { AccessLevelOnIconView } from 'shared/domain/issue/mapping/accessLevel/toOnView/types';
import type { AccessLevelModel } from '../model/types';
import { getAccessLevelExplanationLabel } from './getAccessLevelExplanationLabel';
import { getAccessLevelLabel } from './getAccessLevelLabel';

export function accessLevelModelToOnIconView(
  userAccessLevel: AccessLevelModel
): AccessLevelOnIconView {
  return {
    value: userAccessLevel,
    label: getAccessLevelLabel(userAccessLevel),
    explanationLabel: getAccessLevelExplanationLabel(userAccessLevel),
  };
}
